const NotificationAllReadChecker = ({ notifications }) => {
  const allRead = Array.isArray(notifications) && notifications.every(notification => notification.is_read);

  return (
    <>
      {
        allRead ? (
          'All Clear!'
        )
        : null
      }
    </>
  )
};

export { NotificationAllReadChecker };